export const selectPeopleState = state => state.people;
export const selectSoluterState = state => state.people.soluter;
